import React from "react";
import { Col, Button, Modal, Row ,Image} from "react-bootstrap";
import InputField from "./../../../components/InputFieldComponent";
export const ReasonLessonModal = ({ isOpen, onHide, onChange }) => {
  return (
    <div>
      <Modal
        size="lg"
        className="ProfileStatus-modal"
        show={isOpen}
        onHide={onHide}
      >
        <Modal.Body>
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ padding: "10px 40px", textAlign: "justify" }}
            >
              <div
                className="cancel-btn flex-center-center"
                onClick={onHide}
                style={{
                  fontSize: "17px",
                  width: "30px",
                  height: "30px",
                  marginTop: "20px",
                }}
              >
                <i className="mdi mdi-close"></i>
              </div>
              <div style={{ marginBottom: "50px" }} />
              <h3>We'll let Mawuli know that you are unavilable</h3>
              <div style={{ marginBottom: "30px" }} />

              <div className="modal-para">
                Tell Mawuli why you can't teach the lesson
              </div>
              <div style={{ marginBottom: "30px" }} />
              <InputField
                placeholder="Add details"
                textArea={true}
                style={{
                  height: "80px",
                  border: "none",
                }}
                // value={}
                onChange={onChange}
              />
              <div style={{ marginBottom: "30px" }} />
              <div
                className="flex-between-center"
                style={{ marginTop: "30px" }}
              >
                <div
                  className="green-txt flex-center"
                  onClick={onHide}
                  style={{
                    width: "16px",
                    paddingBottom: "2px",
                    fontFamily: "CircularStdMedium, Arial, sans-serif",
                    fontSize: "16px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                  }}
                >
                  <Image
                    src={require("./../../../assets/icons/back-left.png")}
                    style={{
                      width: "17px",
                    }}
                  />
                  Back
                </div>
                <Button
                  className="green-Button"
                  style={{
                    width: "126px",
                    height: "45px",
                    borderRadius: "5px",
                    fontFamily: "CircularStdMedium, Arial, sans-serif",
                    fontSize: "16px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    color: "#ffffff",
                  }}
                  // onClick={GoOffline}
                >
                  Save
                </Button>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};
